<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body">
      <IFHeaderProfile :headerData="headerData"/>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0 mt-4">
          <h1 class="section_header">Industry Financials</h1>
          <div class="md-toolbar-row fundamentals_wpr p-0">
            <nav-tabs-card no-label md-elevation="0">
              <template slot="content">
                <md-tabs @md-changed="onTabChanged" md-alignment="left" class="p-0">
                  <md-tab
                    id="tab-income"
                    md-label="Income Statement"
                    md-icon="grading"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <nav-tabs-card no-label md-elevation="0">
                        <template slot="content">
                          <md-tabs md-alignment="left" class="p-0">
                            <md-tab
                              id="tab-money"
                              md-label="Percentages"
                              md-icon="percent"
                              class="p-0"
                            >
                              <div class="md-layout">
                                <div class="md-layout-item p-0">
                                  <md-card class="m-0">
                                    <md-card-header>Percentages</md-card-header>
                                    <md-card-content>
                                      <div class="md-layout">
                                        <div
                                          class=" md-layout-item md-medium-size-100 md-size-100 p-0"
                                        >
                                          <md-table
                                            v-model="tableDataPercent"
                                            table-header-color="blue"
                                            class="profit-and-loss-table"
                                          >
                                            <md-table-row
                                              slot="md-table-row"
                                              slot-scope="{ item }"
                                            >
                                              <md-table-cell
                                                :class="item.name ==='Cost of Sales - Labor Portion'
                                                ?'md-table-side-label pl-2'
                                                :'md-table-side-label'"
                                              >
                                                {{ item.name }}
                                                <md-tooltip
                                                  md-direction="bottom"
                                                  >{{
                                                    item.rollover
                                                  }}</md-tooltip
                                                >
                                              </md-table-cell>

                                              <md-table-cell
                                                md-label="Trend"
                                                class="table_chart"
                                              >
                                                <chart-card
                                                  header-animation="false"
                                                  :chart-data="
                                                   newChartPercentOptions[item.name].data
                                                  "
                                                  :chart-options="
                                                   chartOptions
                                                  "
                                                  chart-type="Line"
                                                  header-icon
                                                  chart-inside-content
                                                  no-footer
                                                  background-color="blue"
                                                >
                                                </chart-card>
                                              </md-table-cell>

                                              <md-table-cell
                                                v-for="key in Object.keys(
                                                  item.dates
                                                )"
                                                :key="key"
                                                :md-label="key"
                                                >{{
                                                  item.dates[key]
                                                }}%</md-table-cell
                                              >
                                            </md-table-row>
                                          </md-table>
                                        </div>
                                      </div>
                                    </md-card-content>
                                  </md-card>
                                </div>
                              </div>
                            </md-tab>
                            <md-tab
                              id="tab-payments"
                              md-label="Dollars"
                              md-icon="payments"
                              class="p-0"
                            >
                              <div class="md-layout">
                                <div class="md-layout-item p-0">
                                  <md-card class="m-0">
                                    <md-card-header
                                      >Dollars
                                      <span
                                        >( All figures in USD )</span
                                      ></md-card-header
                                    >
                                    <md-card-content>
                                      <div class="md-layout">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 p-0"
                                        >
                                          <md-table
                                            v-model="tableDataDollar"
                                            table-header-color="blue"
                                            class="profit-and-loss-table"
                                          >
                                            <md-table-row
                                              slot="md-table-row"
                                              slot-scope="{ item }"
                                            >
                                              <md-table-cell
                                                 :class="item.name ==='Cost of Sales - Labor Portion'
                                                ?'md-table-side-label pl-2'
                                                :'md-table-side-label'"
                                              >
                                                {{ item.name }}
                                                <md-tooltip
                                                  md-direction="bottom"
                                                  >{{
                                                    item.rollover
                                                  }}</md-tooltip
                                                >
                                              </md-table-cell>

                                              <md-table-cell
                                                md-label="Trend"
                                                class="table_chart"
                                              >
                                                <chart-card
                                                  header-animation="false"
                                                  :chart-data="
                                                   newChartDollarOptions[item.name].data
                                                  "
                                                  :chart-options="
                                                   chartOptions
                                                  "
                                                  chart-type="Line"
                                                  header-icon
                                                  chart-inside-content
                                                  no-footer
                                                  background-color="blue"
                                                >
                                                </chart-card>
                                              </md-table-cell>

                                              <md-table-cell
                                                v-for="key in Object.keys(
                                                  item.dates
                                                )"
                                                :key="key"
                                                :md-label="key"
                                                >${{
                                                  item.dates[key]
                                                }}</md-table-cell
                                              >
                                            </md-table-row>
                                          </md-table>
                                        </div>
                                      </div>
                                    </md-card-content>
                                  </md-card>
                                </div>
                              </div>
                            </md-tab>
                            <md-tab
                              id="tab-Charts"
                              md-label="Charts"
                              md-icon="pie_chart"
                              class="p-0"
                            >
                              <div class="md-layout">
                                <div class="md-layout-item p-0">
                                  <md-card class="m-0">
                                    <md-card-header
                                      >Charts
                                      <span
                                        >( All figures in USD )</span
                                      ></md-card-header
                                    >
                                    <md-card-content>
                                      <div class="md-layout px-4 mb-4 industry-financials-charts">
                                        <div
                                          v-for="(chart, i) in charts"
                                          :key="i"
                                          :class="'md-layout-item md-medium-size-100 md-size-50 mt-4 ' + formatTitleToClass(chart.title)"
                                        >
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="chart.data"
                                            :chart-options="getOptions(chart.options)"
                                            chart-type="Pie"
                                            header-icon
                                            chart-inside-content
                                            background-color="blue"
                                          >
                                            <template slot="chartInsideHeader">
                                              <h4 class="title m-0">
                                                <div
                                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                                >
                                                  {{ chart.title }}
                                                </div>
                                              </h4>
                                            </template>
                                            <template slot="footer">
                                              <div class="md-layout">
                                                <div
                                                  class="md-layout-item md-size-100"
                                                >
                                                  <h6 class="category">
                                                    Legend
                                                  </h6>
                                                </div>
                                                <div class="md-layout-item">
                                                  <span
                                                    v-for="(v, i) in chart
                                                      .options.legendNames"
                                                    :key="i"
                                                    :class="`ct-series-${i}`"
                                                  >
                                                    <i class="fa fa-circle"></i>
                                                    {{ v }} ({{
                                                      chart.options.labelInterpolationSignFn(
                                                        chart.data.series[i]
                                                      )
                                                    }})
                                                  </span>
                                                </div>
                                              </div>
                                            </template>
                                          </chart-card>
                                        </div>
                                      </div>
                                    </md-card-content>
                                  </md-card>
                                </div>
                              </div>
                            </md-tab>
                          </md-tabs>
                        </template>
                      </nav-tabs-card>
                    </div>
                  </md-tab>
                  <md-tab
                    id="tab-Balance"
                    md-label="Balance Sheet"
                    md-icon="table_chart"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <IFBalanceSheet />
                    </div>
                  </md-tab>
                  <md-tab
                    id="tab-sources"
                    md-label="Sources &amp; Uses of Funds"
                    md-icon="library_books"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <IFSourcesUses />
                    </div>
                  </md-tab>
                </md-tabs>
              </template>
            </nav-tabs-card>
            <IFSidebar />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import IFBalanceSheet from './IFBalanceSheet.vue';
import IFSourcesUses from './IFSourcesUses.vue';
import IFSidebar from './_partials/IFSidebar.vue';
import IFHeaderProfile from './IFHeaderProfile.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    IFBalanceSheet,
    IFSourcesUses,
    IFSidebar,
    IFHeaderProfile
  },
  mixins: [formatData],
  props:['headerData'],
  data() {
    return {
      view: 'dollar',
      options: {
        donut: true,
        showLabel: false,
        legendNames: [],

        labelInterpolationFnc: (value) => value + '$',
        height: '200px',
        width: '200px',
      },
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      newChartDollarOptions: [],
      newChartPercentOptions: [],
      charts: [],
      tableDataDollar: [],
      tableDataPercent: [],
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: '',
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      spif: (state) => state.user.profile.spif,
      chartData: (state) => state.user.profile.chartData['profitLoss'],
      table: (state) => state.user.profile.tables['PL'],
      rolloverAux: (state) => state.user.profile.data[0].array_BB.array_lookup_ALL,
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      BStable: (state) => state.user.profile.tables['BS'],
      tables: (state) => state.user.profile.tables['ratios'],
      tablesInfo: (state) => state.user.profile.tables['ratioInfo'],
      sourcesUses: (state) => state.user.profile['sourcesUses'],
      sourceYears: (state) => state.user.profile['sourcesUses']['years'],
      release_display: (state) => state.user.profile.release_display,
      bznaics_code: (state) => state.user.profile.bznaics,
      sector_name: (state) => state.user.profile.data[0].sector,
      industry_title: (state) => state.user.profile.data[0].industry,
      sales_class: (state) => state.user.profile.data[0].sales_class,
      display_area: (state) => state.user.profile.data[0].display_area,
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    getCsvData() {
      let csvData = [
        ['Industry Financial Report'],
        ['"Release Date"', this.release_display],
        [''],
        ['Segment', 'Industry'],
        [this.industry_title],
        ['[' + parseInt(this.bznaics_code) + ']' + ' Sector', this.sector_name],
        ['Market', this.display_area],
        ['Sales Class', this.sales_class_csv],
        [''],
      ];
      csvData.push(['Firms Analyzed', this.filtered_years]);
      csvData.push(['', this.filtered_firms]);
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss($)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss(%)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet($)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet(%)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Financial Ratios: Cash Flow-Solvency']);
      csvData.push(['', this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Profitability']);
      csvData.push(['', this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Efficiency']);
      csvData.push(['', this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Debt-Risk']);
      csvData.push(['', this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Sources & Uses of Funds']);
      csvData.push(['', this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['Worksheet:']);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      return csvData;
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  mounted() {

    let section = this.$route.query.section;

    if (!section) {
      section = 'dollar';
    }

    this.switchView(section);
    let firmData = Object.values(this.profile.data)
      .filter((item) => item)
      .map((item) => ({ ...item, firms: item.firms }));

    firmData.forEach((element) => {
      this.filtered_firms.push(parseFloat(element.firms));
    });
    if (this.sales_class.includes(',')) {
      this.sales_class_csv = this.sales_class.replace(/,/g, '');
    }
    
    if(this.chartData){
      //delete this.chartData.percentage;
      this.charts = this.formatPieChart(this.chartData);
    }
      


    var rolloverArray = [];
    Object.entries(this.rolloverAux).forEach(([index, item]) => {
      rolloverArray[item.title] = item.description;
    });

    this.tableDataDollar = this.formatTable(this.table, 'industry', 'dollar', rolloverArray);
    this.tableDataPercent = this.formatTable(this.table, 'industry', 'percent', rolloverArray);

    this.profile.years.forEach((e, i) => {
      this.filtered_years.push(Number(e));
    });

    this.tableDataDollar.forEach((element) => {
      let k = Object.values(element.dates);
      if (element.name.includes(',')) {
        element.name = element.name.replace(/,/g, '');
      }
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.name);
      this.filtered_PLDollar.push(v);
    });

    this.tableDataDollar.forEach(element => {

      this.newChartDollarOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, ""))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, ""))]]
        },
      }
    });

    this.tableDataPercent.forEach((element) => {
      let z = Object.values(element.dates);
      if (element.name.includes(',')) {
        element.name = element.name.replace(/,/g, '');
      }
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === 'string' && item.includes(',')) {
          item = parseFloat(item.replace(/,/g, ''));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_PLPercent.push(v);
    });

    this.tableDataPercent.forEach(element => {
      this.newChartPercentOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, ""))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, ""))]]
        },
      }
    });


    let BSpercent = this.formatTable(this.BStable, 'industry', 'percent', rolloverArray);
    let BSdollar = this.formatTable(this.BStable, 'industry', 'dollar', rolloverArray);

    BSdollar.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.name);
      this.filtered_BSDollar.push(v);
    });
    BSpercent.forEach((element) => {
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === 'string' && item.includes(',')) {
          item = parseFloat(item.replace(/,/g, ''));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_BSPercent.push(v);
    });

    if (!_.isEmpty(this.tables)) {
      Object.entries(this.tables).forEach(
        ([table, data]) => this.$set(this, table, this.formatTable(data, 'industry'))
      );
    }
    let cashFlowData = [];
    this.cashflow.forEach((element, index) => {
      if (element.name in this.tables['cashflow']) {
        cashFlowData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    cashFlowData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.cashFlowFilteredData.push(v);
    });

    let efficiencyData = [];
    this.efficiency.forEach((element, index) => {
      if (element.name in this.tables['efficiency']) {
        efficiencyData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    efficiencyData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.efficiencyFilteredData.push(v);
    });

    let profitabilityData = [];
    this.profitability.forEach((element, index) => {
      if (element.name in this.tables['profitability']) {
        profitabilityData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    profitabilityData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.profitabilityFilteredData.push(v);
    });

    let debtRiskData = [];
    this.turnover.forEach((element, index) => {
      if (element.name in this.tables['turnover']) {
        debtRiskData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    debtRiskData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.debtRiskFilteredData.push(v);
    });

    Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
      this.$set(this, table, this.formatSourcesData(table, data))
    );

    this.changein.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.changeinFilteredData.push(k);
    });
    this.worksheet.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.worksheetFilteredData.push(k);
    });
  },
  methods: {
    switchView: function(type) {
      this.view = type;
    },
    getOptions(newOptions) {
      return {
        ...this.options,
        ...newOptions,
      };
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Financial Profile.csv';
      anchor.click();
    },
    labelInterpolation(data) {
      return (value) => {
        return (
          Math.round(
            (value /
              data.reduce(function(a, b) {
                return a + b;
              })) *
              100
          ) + '%'
        );
      };
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];
          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
    onTabChanged(index) {
      if (index === 'tab-income') {
        this.$store.commit(
          'user/SET_ACTIVE_SECTION',
          'IF Industry Financials Income Statement'
        );
      }
      if (index === 'tab-Balance') {
        this.$store.commit(
          'user/SET_ACTIVE_SECTION',
          'IF Industry Financials Balance Sheet'
        );
      }
      if (index === 'tab-sources') {
        this.$store.commit(
          'user/SET_ACTIVE_SECTION',
          'IF Industry Financials Sources & Uses Of Funds'
        );
      }
    },
  },
};
</script>
<style lang="scss">
.if-profile-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
